<div class="tableBasket__empty tableBasket__empty--bigPadding">
    <img alt="Vanta Data Viewer cloud" class="tableBasket_WelcomeImg" src="assets/img/Vanta_DATA-VIEWER_Cloud.png">
    <br>
    <br>
    <p class="tableBasket_emptyText">
        Not seeing all shots from your Vanta? Try leaving your Vanta <br>
        powered on and connected to Evident Connect. Large data sets <br>
        may take some time to complete the sync process.
    </p>
    <p class="tableBasket_emptyText">
        <a href="https://www.olympus-ims.com/en/video/vanta-data-viewer-app-overview/" target="_blank">Vanta Data Viewer overview</a>
    </p>
</div>